import * as React from "react";
const SvgFiRrCommentsQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comments-question_svg__a)">
      <path
        fill="#062147"
        d="M9 11a1 1 0 0 1-1-1c0-1.308 1.038-1.879 1.481-2.123.29-.159.595-.535.502-1.066a1 1 0 0 0-.793-.793 1 1 0 0 0-.832.216A1 1 0 0 0 8 7.001a1 1 0 1 1-2 0 2.996 2.996 0 0 1 3.535-2.952 3.02 3.02 0 0 1 2.417 2.417 3.02 3.02 0 0 1-1.506 3.164c-.447.246-.447.318-.447.371a1 1 0 0 1-1 1zm0 1a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 9 12m10.996-2.92a11 11 0 0 1-.248 2.242A5.99 5.99 0 0 1 22 16v5a1 1 0 0 1-1 1h-5a5.99 5.99 0 0 1-4.678-2.252c-.724.156-1.473.242-2.242.248C10.465 22.385 13.045 24 16 24h5a3 3 0 0 0 3-3v-5c0-2.955-1.615-5.535-4.004-6.92m-2.019.571a9.02 9.02 0 0 0-2.613-7.016A8.99 8.99 0 0 0 8.349.023C3.823.343 0 4.589 0 9.296v5.038A3.67 3.67 0 0 0 3.661 18h4.477c5.187 0 9.509-3.667 9.839-8.349M13.95 4.05a7.02 7.02 0 0 1 2.033 5.46c-.253 3.578-3.772 6.489-7.845 6.489H3.661A1.665 1.665 0 0 1 2 14.333V9.295c0-3.696 2.972-7.029 6.49-7.278q.25-.018.499-.018c1.858 0 3.644.732 4.961 2.051"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comments-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentsQuestion;
